module.exports = __webpack_public_path__ + "img/bgabs.31453d26.png";